
<style lang="less" scoped>
.otherNames {
  border: 1px solid #292828;
  padding: 2px 3px;
  margin-right: 5px;
  font-size: 12px;
  display: inline-block;
  border-radius: 5px;
  margin-bottom: 5px;
}
@media screen and (min-width: 500px) {
  @import "../assets/css/pcCom.less";
  .mobile-swiper {
    display: none;
  }
  .card {
    display: none;
  }

  .content {
    background: rgb(248, 248, 241);
    padding: 25px 0;
  }
  .pcBanner img {
    border-radius: inherit !important;
    width: 100%;
  }
  .pcBanner-content {
    margin-top: 35px;
    width: 60%;
  }
  .information {
    background: #f0f3e2;
    padding: 5px 56px 15px 25px;
    margin-top: 25px;
  }
  .banner {
    display: none;
  }
  .pcGrade {
    margin-top: 25px;
    img {
      width: 30px;
      vertical-align: middle;
      margin-right: 3px;
    }
    h2 {
      margin-bottom: 15px;
      font-size: 20px;
      color: #000000;
    }
    p {
      line-height: 35px;
      color: #333;
      font-size: 18px;

      span {
        width: 100px;
        display: inline-block;
        color: #4b3a0e !important;
        font-weight: 700 !important;
      }
    }
  }

  .literature ul li {
    padding: 8px 0;
  }
  /deep/.ivu-tabs-nav .ivu-tabs-tab {
    font-size: 20px;
    height: 45px;
    color: #333;
  }
  /deep/.ivu-tabs-bar {
    background: #f0f3e2;
  }
}
@media screen and (max-width: 500px) {
  @import "../assets/css/mobileCom.less";
  .pcBanner {
    display: none;
  }
  .pc-basic {
    display: none;
  }
  .otherNames {
  }
  .content {
    .images {
      img {
        width: 100px;
        height: 80px;
      }
    }
  }

  .banner {
    text-align: center;
    background: #e6e6e6;
    padding-top: 15px;
    padding-bottom: 5px;

    img {
      width: 300px;
      height: 200px;
    }
  }

  .grade span {
    // width: 100px !important;
    display: inline-block;
  }
}
</style>
<template>
  <!-- <comHeader></comHeader> -->
  <div class="content">
    
    <!-- pc端 -->
    <div class="pcBanner">
      <div class="swiper-container pc-swiper">
        <div
          class="swiper-wrapper"
          v-if="associatedMedia && associatedMedia.length > 0"
        >
          <div
            class="swiper-slide"
            v-for="(item, index) in associatedMedia"
            :key="index"
          >
            <img :src="item.link" />
          </div>
        </div>
        <div class="swiper-wrapper" v-else>
          <div class="swiper-slide">
            <img style="height: 300px" src="@/assets/image/nodata1.png" />
          </div>
        </div>
      </div>
      <div class="pcBanner-content">
        <h1>{{ datas.vernacular_name }}</h1>
        <h2 class="otherName">
          <i>{{ datas.scientific_name }}</i
          ><span>{{ datas.author }}（{{ datas.published_year }}）</span>
        </h2>
        <h3 class="parse">
          <a :href="'http://cstr.cn/' + datas.identifier" target="_blank">
            CSTR:{{ datas.identifier }}</a
          >
        </h3>

        <h4 v-if="datas.taxonomic_status == 'accepted'">
          <span>分类状态：此物种已被接受</span>
        </h4>
        <h4 v-if="datas.taxonomic_status == 'Synonym'">
          <span
            >分类状态：异名，同义词，表示这个名称是另一个已接受名称的同义词物种。</span
          >
        </h4>
        <h4 v-if="datas.taxonomic_status == 'Unsolved'">
          <span>表示该物种或分类仍然存在争议或不确定性。</span>
        </h4>
        <h4>
          <span style="margin-right: 30px"
            >分类群等级：{{ formatTaxonRank(datas.taxon_rank) }}</span
          >
          <span>界：植物界</span>
        </h4>
      </div>
    </div>
    <div class="banner">
      <div class="mobile-swiper swiper-container mySwiper2">
        <div class="swiper-wrapper">
          <div
            class="swiper-slide"
            v-for="(item, index) in associatedMedia"
            :key="index"
          >
            <img :src="item.link" />
          </div>
          <div class="swiper-slide">
            <img src="@/assets/image/daurica1.png" />
          </div>
        </div>
      </div>
    </div>

    <!-- 移动端 -->
    <div class="basic">
      <div class="intro card">
        <h2 class="title">{{ datas.vernacular_name }}</h2>
        <h3 class="otherName">
          <i>{{ datas.scientific_name }}</i
          ><span>{{ datas.author }}({{ datas.published_year }})</span>
        </h3>
        <h4 class="family">
          <a :href="'http://cstr.cn/' + datas.identifier">
            CSTR:{{ datas.identifier }}</a
          >
        </h4>
        <h5 v-if="datas.taxonomic_status == 'accepted'">
          <span style="margin-right: 25px">此物种已被接受。</span>
        </h5>
        <h5 v-if="datas.taxonomic_status == 'Synonym'">
          <span
            >异名，同义词，表示这个名称是另一个已接受名称的同义词物种。</span
          >
        </h5>
        <h5 v-if="datas.taxonomic_status == 'Unsolved'">
          <span>表示该物种或分类仍然存在争议或不确定性。</span>
        </h5>
      </div>
      <div
        class="intro detail"
        v-if="
          datas.other_names &&
          datas.other_names.length > 0 &&
          datas.other_names[0] != ''
        "
      >
        <h2><img src="@/assets/image/icon.png" />别名</h2>
        <span
          class="otherNames"
          v-for="(item, index) in datas.other_names"
          :key="index"
        >
          {{ item }}
        </span>
      </div>
      <div
        class="intro detail"
        v-if="
          datas.taxonomic_status != 'accepted' &&
          datas.related_identifiers &&
          datas.related_identifiers.length > 0
        "
      >
        <h2><img src="@/assets/image/icon.png" />接受名编码</h2>
        <p
          v-if="
            datas.related_identifiers && datas.related_identifiers.length > 0
          "
        >
          <a
            :href="'http://cstr.cn/' + datas.related_identifiers[0].identifier"
          >
            CSTR:{{ datas.related_identifiers[0].identifier }}</a
          >
        </p>
      </div>
      <!-- <div class="intro detail">
        <h2><img src="@/assets/image/bush.png" />父阶元编码</h2>
        <p>
          <a>CSTR:32129.{{ data.parentNameUsageID }}</a>
        </p>
      </div> -->

      <div class="intro detail grade">
        <h2><img src="@/assets/image/leaf1.png" />物种保护</h2>
        <div class="protect-list">
          <ul>
            <!-- <li>
              <span>
                国家重点野生保护物种等级
                <i>{{ data.dynamicProperties.protectedStatusOfChina }}</i>
              </span>
            </li>
            <li>
              <span>
                云南省重点保护物种等级　
                <i>{{ data.dynamicProperties.protectedStatusOfYunnan }}</i>
              </span>
            </li> -->
            <li>
              <span>
                CITES附录 　　　　　　　<i>{{
                  formatCites(datas.cites_status)
                }}</i>
              </span>
            </li>
            <li>
              <span>
                红色名录等级　　　　　　<i>{{ datas.iucn_status }}</i>
              </span>
            </li>
            <!-- <li>
              <span>
                区域分布状态　　　　　　<i>{{
                  data.dynamicProperties.degreeOfEstablishment
                }}</i>
              </span>
            </li> -->
          </ul>
        </div>
      </div>
      <!-- <div class="intro detail">
        <h2>
          <img src="@/assets/image/leaf.png" style="width: 23px" />相关链接
        </h2>
        <div class="protect-list">
          <p>
            <span>植物志：</span
            ><a :href="data.references.IPLANT">{{ data.references.IPLANT }}</a>
          </p>
          <p>
            <span>邱　园：</span
            ><a :href="data.references.POWO">{{ data.references.POWO }}</a>
          </p>
        </div>
      </div>
      <div class="intro detail">
        <h2>
          <img src="@/assets/image/leaf.png" style="width: 23px" />引用方式
        </h2>

        <p class="quote">
          {{ data.scientificNameAuthorship }}
          {{ data.publicationYear }}. <i>{{ data.scientificName }}</i> var.
          beipiaoensis in SCBG.
          <a id="copydata">
            https://cstr.cn/32129.45.P.Euonymus.acanthocarpus.CN.SCBG.NOINAME:9705</a
          >
        </p>
      </div>
      <div class="intro detail grade">
        <h2><img src="@/assets/image/leaf1.png" />标 本</h2>
        <ul style="padding-left: 0">
          <li>
            <a href="/#/users/specimen">CSTR:32129.10.2.1.SCBG.1485703</a
            ><span>- <i>Lespedeza daurica</i> (Laxm.) Schindl.</span>
          </li>
          <li>
            <a href="https://noi.link/view/data_detail/id/3594355"
              >CSTR:32129.10.2.1.SCBG.1485703</a
            ><span>- <i>Lespedeza daurica</i> (Laxm.) Schindl.</span>
          </li>
        </ul>
      </div>
      <div class="intro detail">
        <h2><img src="@/assets/image/icon-flora.svg" />相关文献</h2>
        <ul>
          <li>
            <span> [1]</span>
            <a
              href="https://link.cnki.net/doi/10.27011/d.cnki.gdbsu.2022.000215"
              target="_blank"
            >
              韩佳育.
              羊草和兴安胡枝子功能性状和种间关系对降水格局变化的响应[D].东北师范大学,2023.DOI:10.27011/d.cnki.gdbsu.2022.000215.</a
            >
          </li>
          <li>
            <span> [2]</span
            ><a
              href="https://link.cnki.net/doi/10.27210/d.cnki.glnju.2021.000301"
              target="_blank"
              >李媛.
              土壤粗化对兴安胡枝子生理生长及种群生态特征的影响[D].辽宁工程技术大学,2022.DOI:10.27210/d.cnki.glnju.2021.000301.</a
            >
          </li>
          <li>
            <span> [3]</span
            ><a
              href="https://kns.cnki.net/kcms2/article/abstract?v=8WLnD7pOpNH4VF0yUfKDGxAGCmoM7BIdgifuwj4VLpHTsi3SnXJfYheMpXaA6_ZTBItQTy58R8hiVyUXQyhpqlpW-9WxRTxpQJdF-e3NdfB5ckNSBPkhH0JPd6-FIFfGBitsLBoBggq-5fL6S8-hMQ==&uniplatform=NZKPT&language=CHS"
              target="_blank"
              >顾国海,吕凤春,曾宪楠,等.林下和林缘兴安胡枝子叶片PSⅡ行为对光强的快速响应[J].北方园艺,2018(23):71-79.</a
            >
          </li>
        </ul>
      </div> -->
    </div>
    <!-- pc端 -->
    <div class="pc-basic">
      <div class="tablist">
        <Tabs value="name1" style="width: 100%">
          <TabPane label="基本信息" name="name1">
            <div class="container-right">
              <div class="codes">
                <div class="codes-left">
                  <div
                    class="features"
                    v-if="
                      datas.other_names &&
                      datas.other_names.length > 0 &&
                      datas.other_names[0] != ''
                    "
                  >
                    <h2><img src="@/assets/image/leaf.png" />别名</h2>
                    <span
                      class="otherNames"
                      v-for="(item, index) in datas.other_names"
                      :key="index"
                    >
                      {{ item }}
                    </span>
                  </div>
                  <div
                    class="features"
                    v-if="
                      datas.taxonomic_status != 'accepted' &&
                      datas.related_identifiers &&
                      datas.related_identifiers.length > 0
                    "
                  >
                    <h2><img src="@/assets/image/leaf.png" />接受名编码</h2>
                    <p
                      v-if="
                        datas.related_identifiers &&
                        datas.related_identifiers.length > 0
                      "
                    >
                      <a
                        :href="
                          'http://cstr.cn/' +
                          datas.related_identifiers[0].identifier
                        "
                        target="_blank"
                      >
                        CSTR:{{ datas.related_identifiers[0].identifier }}</a
                      >
                    </p>
                  </div>
                </div>
              </div>
              <div class="features life" id="species">
                <h2><img src="@/assets/image/leaf.png" />物种保护</h2>
                <div class="protect-list">
                  <ul>
                    <!-- <li>
                      <span>
                        国家重点野生保护物种等级
                        <i>{{
                          data.dynamicProperties.protectedStatusOfChina
                        }}</i>
                      </span>
                    </li>
                    <li>
                      <span>
                        云南省重点保护物种等级　
                        <i>{{
                          data.dynamicProperties.protectedStatusOfYunnan
                        }}</i>
                      </span>
                    </li> -->
                    <li>
                      <span>
                        CITES附录 　　　　　　　<i>{{
                          formatCites(datas.cites_status)
                        }}</i>
                      </span>
                    </li>
                    <li>
                      <span>
                        红色名录等级　　　　　　<i>{{
                          formIucnStatus(datas.iucn_status)
                        }}</i>
                      </span>
                    </li>
                    <!-- <li>
                      <span>
                        区域分布状态　　　　　　<i>{{
                          data.dynamicProperties.degreeOfEstablishment
                        }}</i>
                      </span>
                    </li> -->
                  </ul>
                </div>
              </div>
              <div
                class="features life"
                id="species"
                v-if="associatedMedia && associatedMedia.length > 0"
              >
                <h2><img src="@/assets/image/leaf.png" />相关图片</h2>
                <div class="tabImages">
                  <img
                    v-for="(item, index) in associatedMedia"
                    :key="index"
                    :src="item.link"
                  />
                </div>
              </div>
              <!-- <div class="features life">
                <h2><img src="@/assets/image/leaf.png" />引用方式</h2>
                <p class="quote">
                  {{ data.scientificNameAuthorship }}
                  {{ data.publicationYear }}.
                  <i>{{ data.scientificName }}</i> var. beipiaoensis in SCBG.
                  <a id="copydata">
                    https://cstr.cn/32129.45.P.Euonymus.acanthocarpus.CN.SCBG.NOINAME:9705</a
                  >
                  <a
                    @click="copyData"
                    id="copyLink"
                    data-clipboard-action="copy"
                    data-clipboard-target="#copydata"
                    ><img src="@/assets/image/copy.png"
                  /></a>
                </p>
              </div> -->
            </div>
          </TabPane>
          <!-- <TabPane label="图片" name="name2">
            <div class="tabImages">
              <img
                v-for="(item, index) in associatedMedia"
                :key="index"
                :src="item"
              />
            </div>
          </TabPane> -->
          <!-- <TabPane label="植株" name="name3">
            <div class="tabContent">
              <ul style="padding-left: 0">
                <li>
                  <a href="/#/users/plant" target="_blank"
                    >CSTR:32129.46.2.SCBG.67890</a
                  ><span
                    >- <i>{{ data.scientificName }}</i>
                    {{ data.scientificNameAuthorship }}</span
                  >
                  <span>中国 广东省 广州市</span>
                </li>
              </ul>
            </div>
          </TabPane>
          <TabPane label="标本" name="name4">
            <div class="tabContent">
              <ul style="padding-left: 0">
                <li>
                  <a href="/#/users/specimen" target="_blank"
                    >CSTR:32129.10.2.IBSC.1213234</a
                  ><span
                    >- <i>{{ data.scientificName }}</i>
                    {{ data.scientificNameAuthorship }}</span
                  >
                  <span>中国 广东省 广州市</span>
                </li>
                <li>
                  <a
                    href="https://www.cvh.ac.cn/spms/detail.php?id=e826f512"
                    target="_blank"
                    >CSTR:32129.10.2.IBSC.01999121</a
                  ><span
                    >- <i>{{ data.scientificName }}</i>
                    {{ data.scientificNameAuthorship }}</span
                  >
                  <span>中国 广西壮族自治区</span>
                </li>
                <li>
                  <a
                    href="https://www.cvh.ac.cn/spms/detail.php?id=e826f5a0"
                    target="_blank"
                    >CSTR:32129.10.2.IBSC.01999120</a
                  ><span
                    >- <i>{{ data.scientificName }}</i>
                    {{ data.scientificNameAuthorship }}</span
                  >
                  <span> 中国 云南省</span>
                </li>

                <li>
                  <a
                    href="https://www.cvh.ac.cn/spms/detail.php?id=e826f632"
                    target="_blank"
                    >CSTR:32129.10.2.IBSC.01999119</a
                  ><span
                    >- <i>{{ data.scientificName }}</i>
                    {{ data.scientificNameAuthorship }}</span
                  >
                  <span> 中国 云南省</span>
                </li>
              </ul>
            </div>
          </TabPane>

          <TabPane label="相关文献" name="name6">
            <div class="publication">
              <ul>
                <li>
                  <span> </span
                  ><a
                    href="https://kns.cnki.net/kcms2/article/abstract?v=8WLnD7pOpNEvKSinkbJEWGW7kmKG2kLnMWppe47RxUhI3NU1KeYi1b4BbN_QF3GxXg-3k8c0LfxPVfPDZOUs1x_xIQ9kzDqVxNuYjEQhg-1URwyu9-7FCRC_uy31P_HwudwMxuVxklg=&uniplatform=NZKPT&language=CHS"
                    >吴德东,周景荣.草牧场防护林对碱草、兴安胡枝子蒸腾效率的影响[J].辽宁林业科技,1994(02):22-23.</a
                  >
                </li>
                <li>
                  <span> </span
                  ><a
                    href="https://kns.cnki.net/kcms2/article/abstract?v=8WLnD7pOpNEqe-CAV-KlnV-E4S0Rpdkhvbp1si_pCcnFkQskrZPbkx48YPiSPbIGBRqL98cnbIqPE1tfUcfBNlYDhiutGB9XU71lxkwgxwwxc_ZVpPyiY91SzQJX9YQImL4R89yPvIKQAhqVSeIgYQ==&uniplatform=NZKPT&language=CHS"
                    >王永奇,吕琳,姜妍,等.兴安胡枝子化学成分的研究[J].中草药,1992,23(02):63-65+111.</a
                  >
                </li>
                <li>
                  <span> </span>
                  <a
                    href="https://link.cnki.net/doi/10.27011/d.cnki.gdbsu.2022.000215"
                    target="_blank"
                  >
                    韩佳育.
                    羊草和兴安胡枝子功能性状和种间关系对降水格局变化的响应[D].东北师范大学,2023.DOI:10.27011/d.cnki.gdbsu.2022.000215.</a
                  >
                </li>
                <li>
                  <span></span
                  ><a
                    href="https://link.cnki.net/doi/10.27210/d.cnki.glnju.2021.000301"
                    target="_blank"
                    >李媛.
                    土壤粗化对兴安胡枝子生理生长及种群生态特征的影响[D].辽宁工程技术大学,2022.DOI:10.27210/d.cnki.glnju.2021.000301.</a
                  >
                </li>
                <li>
                  <span></span
                  ><a
                    href="https://kns.cnki.net/kcms2/article/abstract?v=8WLnD7pOpNH4VF0yUfKDGxAGCmoM7BIdgifuwj4VLpHTsi3SnXJfYheMpXaA6_ZTBItQTy58R8hiVyUXQyhpqlpW-9WxRTxpQJdF-e3NdfB5ckNSBPkhH0JPd6-FIFfGBitsLBoBggq-5fL6S8-hMQ==&uniplatform=NZKPT&language=CHS"
                    target="_blank"
                    >顾国海,吕凤春,曾宪楠,等.林下和林缘兴安胡枝子叶片PSⅡ行为对光强的快速响应[J].北方园艺,2018(23):71-79.</a
                  >
                </li>
              </ul>
            </div>
          </TabPane> -->
        </Tabs>
      </div>
    </div>
  </div>
</template>
<script>
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/swiper-bundle.css";
import axios from "axios";
import jsonpAdapter from "axios-jsonp";
import $ from "jquery";
import comHeader from "@/components/header.vue";
export default {
  components: {
    Swiper,
    SwiperSlide,
    comHeader,
  },

  data() {
    return {
      associatedMedia: [],
      identifier: "",
      datas: {},
    };
  },
  mounted() {
    this.identifier = this.$getUrlParam("identifier");
    this.getSpeciesInfo();
    const swiper = new this.$Swiper(".mySwiper2", {
      spaceBetween: 10,
      loop: true,
      autoplay: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
  },
  methods: {
    formatCites(citesStatus) {
      if (citesStatus === "NotListed") {
        return "未列入附录的物种"; // 具体格式化逻辑请替换
      } else {
        return citesStatus;
      }
    },
    formIucnStatus(val) {
      if (val === "LC") {
        return "无危";
      } else if (val === "NT") {
        return "近危";
      } else if (val === "VU") {
        return "易危";
      } else if (val === "EN") {
        return "濒危";
      } else if (val === "CR") {
        return "极危";
      } else if (val === "EW") {
        return "野外灭绝";
      } else if (val === "EX") {
        return "灭绝";
      } else if (val === "DD") {
        return "数据缺乏";
      } else {
        return "未评估";
      }
    },
    formatTaxonRank(val) {
      if (val === "Species") {
        return "种";
      } else if (val === "Genus") {
        return "属";
      } else if (val === "Family") {
        return "科";
      } else if (val === "Order") {
        return "目";
      } else if (val === "Class") {
        return "类";
      } else if (val === "Phylum") {
        return "门";
      } else if (val === "Kingdom") {
        return "界";
      } else {
        return "变种";
      }
    },
    // 物种信息
    getSpeciesInfo() {
      axios({
        url: "https://www.cstr.cn/openapi/v3/portal/api/public/detail?identifier=" + this.identifier,
        adapter: jsonpAdapter,
        headers: {
          clientId: "202409131725",
          secret: "d1f54c58e0143af9127ece0ada255838",
        },
      }).then((response) => {
        if (response.data.code === 200) {
          this.datas = response.data.data;
          console.log(this.datas);
          this.associatedMedia = this.datas.medias;
        } else {
          console.log("获取物种信息失败");
        }
      }).catch(error => {
        console.error("请求错误:", error);
      });
    },
  },
};
</script>